import React from 'react';
import { Box, ButtonGroup, Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import {
  AddCircleOutline as CreateIcon,
  Dashboard as DashboardIcon,
  Article as TemplateIcon,
  Group as GroupIcon
} from '@mui/icons-material';

const getActiveTabIndex = (path) => {
  if (path === '/newsletter') return 0;
  if (path.startsWith('/newsletter/dashboard')) return 1;
  if (path.startsWith('/newsletter/templates')) return 2;
  if (path.startsWith('/newsletter/groups')) return 3;
  return 0;
};

const NewsletterTabs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const activeTab = getActiveTabIndex(location.pathname);

  const isAdmin = user?.role === 'admin' || user?.role === 'mensure';

  const tabs = [
    { index: 0, path: '/newsletter', icon: <CreateIcon sx={{ fontSize: '1.2rem', mr: 0.75, mb: '-2px' }} />, label: 'Nova Newsletter' },
    { index: 1, path: '/newsletter/dashboard', icon: <DashboardIcon sx={{ fontSize: '1.2rem', mr: 0.75, mb: '-2px' }} />, label: 'Dashboard' },
    ...(isAdmin ? [{ index: 2, path: '/newsletter/templates', icon: <TemplateIcon sx={{ fontSize: '1.2rem', mr: 0.75, mb: '-2px' }} />, label: 'Templates', mobileHidden: true }] : []),
    { index: isAdmin ? 3 : 2, path: '/newsletter/groups', icon: <GroupIcon sx={{ fontSize: '1.2rem', mr: 0.75, mb: '-2px' }} />, label: 'Grupos', mobileHidden: true }
  ];

  return (
    <Box sx={{ mb: { xs: 2, md: 4 } }}>
      <ButtonGroup fullWidth size="medium" variant="outlined" sx={{ width: { xs: '100%', sm: 'auto' }, borderRadius: 2, '& .MuiButtonGroup-grouped': { borderColor: 'divider' } }}>
        {tabs.map((tab) => (
          <Button
            key={tab.index}
            variant={activeTab === tab.index ? 'contained' : 'outlined'}
            onClick={() => navigate(tab.path)}
            sx={{
              display: tab.mobileHidden ? { xs: 'none', md: 'inline-flex' } : 'inline-flex',
              flex: { xs: 1, sm: 'initial' },
              px: { xs: 2, sm: 3 },
              py: 0.75,
              fontWeight: activeTab === tab.index ? 700 : 500,
              textTransform: 'none'
            }}
          >
            {tab.icon}
            {tab.label}
          </Button>
        ))}
      </ButtonGroup>
    </Box>
  );
};

export default NewsletterTabs;
